import downloadCSV from './downloadCSV'
import downloadXLSX from './downloadXLSX'

/**
 * De downloadfunctie bij het bestandsformaat dat de gebruiker koos. Eén plek
 * voor de keuze, zodat de knoppen bij outputresultaten en onderzoeksresultaten
 * (Instellingen → Data) hetzelfde doen.
 *
 * @param {'xlsx' | 'csv'} format
 * @returns {typeof downloadCSV} Neemt (rows, filename, headerOrder) en geeft false als er niets te exporteren viel
 */
const downloaderFor = (format) => (format === 'xlsx' ? downloadXLSX : downloadCSV)

export default downloaderFor
